import React from 'react';
import './FilterBox.scss';
import { Link } from 'react-router-dom';
import { FilterProps } from './models/FilterBoxModel';

const FilterBox: React.FC<FilterProps> = ({ additionalClass, items, children }) => {
  return (
    <div className={`filter-box ${additionalClass ?? ''}`}>
      {items && items.length > 0 && (
        <div className="filter-box__tabs">
          {items.map((data, index) => {
            const className = `filter-box__item ${
              data.isActive ? 'filter-box__item--active' : ''
            }`;
            const key = `filter-box-${data.label}-${index}`;

            if (data.url) {
              return (
                <Link to={data.url} className={className} key={key}>
                  {data.label}
                </Link>
              );
            }

            return (
              <button
                type="button"
                className={className}
                key={key}
                onClick={data.onClick}
              >
                {data.label}
              </button>
            );
          })}
        </div>
      )}
      {children && <div className="filter-box__content">{children}</div>}
    </div>
  );
};

export default FilterBox;
